/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import { Form, Row, Col, Typography, Divider } from 'antd'
import { CustomTextInput } from 'src/components'
import {
  getCountriesList, setUserPersonalDataForm, createUser,
  userPersonalData, userCredentials, resetUserRegisterState
} from 'src/features'
import styles from './PersonalDataFormStep.module.scss'
import StepChanger from '../StepChanger/StepChanger'
import CountrySelectForRegister from '../CountrySelectForRegister/CountrySelectForRegister'
import { showNotification } from 'src/core/helpers'
const { Title } = Typography

interface CredentialsFormStepProps {
  isOnlyOffsetter: boolean
}

const CredentialsFormStep: React.FC<CredentialsFormStepProps> = (props) => {
  const { isOnlyOffsetter } = props
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const userPersonalDataValue = useAppSelector(userPersonalData)
  const userCredentialsValue = useAppSelector(userCredentials)
  /* Country Selector */
  const {
    loading: loadingCountries,
  } = useAppSelector((state) => state.countrySlice.countryList)
  /* User Create Selector */
  const {
    loading: loadingUserCreation,
    error: userCreateError
  } = useAppSelector((state) => state.users.registerUser)


  const onFinish = (userPersonalData: any) => {
    dispatch(setUserPersonalDataForm(userPersonalData))
    dispatch(createUser({
      personalData: userPersonalData,
      credentials: userCredentialsValue
    }, isOnlyOffsetter))
  }

  useEffect(() => {
    dispatch(getCountriesList())
  }, [dispatch])

  useEffect(() => {
    if (userCreateError) {
      showNotification('error', userCreateError)
      dispatch(resetUserRegisterState())
    }
  }, [userCreateError])

  useEffect(() => {
    form.setFieldsValue({
      ['firstName']: userPersonalDataValue.firstName,
      ['lastName']: userPersonalDataValue.lastName,
      ['companyName']: userPersonalDataValue.companyName,
      ['country']: userPersonalDataValue.country,
    })
    // eslint-disable-next-line no-use-before-define
  }, [userPersonalDataValue])

  return (
    <>
      <Form
        name='personalDataForm'
        onFinish={onFinish}
        autoComplete='off'
        className='mt-3'
        form={form}
      >
        <Row>
          <Col xs={24} lg={12} className={styles['padding-col']}>
            {/* First Name */}
            <Title level={5} type='secondary' className={styles['label-text']}>{t('admin.Brokerage.FirstName')}</Title>
            <CustomTextInput
              name={'firstName'}
              placeholder={t('admin.Brokerage.FirstNamePlaceHolder')}
              required
            />
          </Col>
          <Col xs={24} lg={12} className={styles['padding-col']}>
            {/* last Name */}
            <Title level={5} type='secondary' className={styles['label-text']}>{t('admin.Brokerage.LastName')}</Title>
            <CustomTextInput
              name={'lastName'}
              placeholder={t('admin.Brokerage.LastNamePlaceHolder')}
              required
            />
          </Col>
        </Row>

        {/* Company Divider */}
        <Divider orientation='left' plain>
          <Title level={5} type='secondary'>
            {t('admin.Brokerage.CompanyLabel')}
          </Title>
        </Divider>

        {/* Company Data */}
        <Row>
          <Col xs={24} lg={12} className={styles['padding-col']}>
            <Title level={5} type='secondary' className={styles['label-text']}>{t('admin.Brokerage.CompanyName')}</Title>
            <CustomTextInput
              name={'companyName'}
              placeholder={t('admin.Brokerage.CompanyNamePlaceholder')}
              required
            />
          </Col>
          <Col xs={24} lg={12} className={styles['padding-col']}>
            <CountrySelectForRegister loading={loadingCountries} />
          </Col>
        </Row>
        {/* Buttons Content */}
        <StepChanger nextStepValue={1} beforeStepValue={0} loading={loadingUserCreation} />
      </Form>
    </>
  )
}

export default CredentialsFormStep
